export default {
  budgets: state => state.budgets,
  currentBudget: state => state.currentBudget,
  filters: state => state.filters,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCallingBudgets: state => state.isCallingBudgets
}
